import moment from "moment";
import { FC } from "react";
import styled from "styled-components";
import { CustomerWithUserCustomers } from "../../../api/models/CustomerWithUserCustomers";
import { UserCustomer } from "../../../api/models/UserCustomer";
import useCustomTranslation from "../../hooks/CustomUseTranslation";

export const LongTextTableColumn = styled.td`
    width:350px;
    max-width: 350px;
    overflow: hidden;
`

export interface OrganizationCustomerItemProps {
    customer: CustomerWithUserCustomers;
    activeTab: string;
}

const OrganizationCustomerItem: FC<OrganizationCustomerItemProps> = (props) => {
    var currentDate = new Date()
    var today = moment(currentDate).format('yyyy-MM-DDTHH:mm:ss+SSSS')
    var activeLinkings: UserCustomer[] = [];
    const { t } = useCustomTranslation();

    //We only want to list users that have active linkings
    props.customer.userCustomers.forEach((user) => {
        if (user.startDate !== null && user.endDate !== null) {
            var startDate = moment(user.startDate).format('yyyy-MM-DDTHH:mm:ss+SSSS')
            var endDate = moment(user.endDate).format('yyyy-MM-DDTHH:mm:ss+SSSS')
            if ((user.startDate === undefined || startDate < today) && (user.endDate === undefined || endDate > today)) {
                activeLinkings.push(user)
            }
        }
    })

    let uniqueUsernames = Array.from(new Set(activeLinkings.map(user => user.user.username)));

    return (
        /*<Fragment>
            {props.activeTab === 'customerNumbers' &&
                <Fragment>
                    <NestedTableRow>
                        <NestedTableColumn>
                            {props.customer.customerNumber}
                        </NestedTableColumn>
                    </NestedTableRow>
                </Fragment>}
            {props.activeTab === 'usernames' &&
                <Fragment>
                    {uniqueUsernames.map((user, index) => (
                        <NestedTableRow key={index}>
                            <LongTextTableColumn>
                                  {user}
                            </LongTextTableColumn>
                            <NestedTableColumn>
                            {t("Links to ")} <b>{props.customer.customerNumber}</b>
                            </NestedTableColumn>
                        </NestedTableRow>))}
                </Fragment>}

        </Fragment>*/
        <>
            {props.activeTab === 'customerNumbers' && 
                <tr style={{ paddingLeft: '40px' }}>
                    <td>
                        {props.customer.customerNumber}
                    </td>
                </tr>
            }
        
            {props.activeTab === 'usernames' &&
                <>
                    {uniqueUsernames.map((user, index) => (
                        <tr style={{ paddingLeft: '40px' }}>
                            <td>
                                {user}
                            </td>
                            <td>
                                {t("Links to ")} <b>{props.customer.customerNumber}</b>
                            </td>
                        </tr>
                    ))}
                </>
            }
        </>
    )
}

export default OrganizationCustomerItem;